{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Налаштування облікового запису",
    "SUBMIT": "Оновити налаштування",
    "BACK": "Назад",
    "DISMISS": "Відхилити",
    "UPDATE": {
      "ERROR": "Не вдалося оновити налаштування, спробуйте ще раз!",
      "SUCCESS": "Налаштування облікового запису успішно оновлено"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Видалити",
        "DISMISS": "Скасувати",
        "PLACE_HOLDER": "Будь ласка, введіть {accountName} щоб підтвердити"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Будь ласка, виправте помилки форми",
      "GENERAL_SECTION": {
        "TITLE": "Загальні налаштування",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID акаунту",
        "NOTE": "Цей ID необхідний, якщо ви створюєте інтеграцію з API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Налаштування",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Назва облікового запису",
        "PLACEHOLDER": "Ім'я вашого облікового запису",
        "ERROR": "Будь ласка, введіть правильне ім'я облікового запису"
      },
      "LANGUAGE": {
        "LABEL": "Мова сайту",
        "PLACEHOLDER": "Ім'я вашого облікового запису",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Домен вхідної пошти",
        "PLACEHOLDER": "Домен, на який ви будете отримувати електронні листи",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email підтримки",
        "PLACEHOLDER": "Email підтримки вашої компанії",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Оновити",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Продовження діалогу з е-поштою активоване для вашого облікового запису.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Тепер ви можете отримувати електронні листи на власний домен."
      }
    },
    "UPDATE_CHATWOOT": "Доступне оновлення {latestChatwootVersion} для Chatwoot. Будь ласка, оновіть вашу копію.",
    "LEARN_MORE": "Детальніше",
    "PAYMENT_PENDING": "Очікується ваш платіж. Будь ласка, оновіть вашу платіжну інформацію, щоб продовжити використовувати Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "В вашому обліковому записі перевищено ліміт використання, будь ласка, поновіть ваш план, щоб продовжити використання Chatwoot",
    "OPEN_BILLING": "Відкрити рахунок"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Натисніть Enter, щоб обрати",
      "ENTER_TO_REMOVE": "Натисніть Enter, щоб видалити",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Виберіть",
      "SELECT": "Обрати"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Сповіщення",
    "MARK_ALL_DONE": "Позначити все готове",
    "DELETE_TITLE": "видалено",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Непрочитані сповіщення",
      "ALL_NOTIFICATIONS": "Переглянути всі сповіщення",
      "LOADING_UNREAD_MESSAGE": "Завантаження непрочитаних сповіщень...",
      "EMPTY_MESSAGE": "У вас немає непрочитаних сповіщень"
    },
    "LIST": {
      "LOADING_MESSAGE": "Завантаження сповіщень...",
      "404": "Немає сповіщень",
      "TABLE_HEADER": [
        "Ім'я",
        "Номер телефону",
        "Бесіди",
        "Останній контакт"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Новий діалог",
      "conversation_assignment": "Діалог призначений",
      "assigned_conversation_new_message": "Нове повідомлення",
      "participating_conversation_new_message": "Нове повідомлення",
      "conversation_mention": "Відмітка",
      "sla_missed_first_response": "SLA пропущено",
      "sla_missed_next_response": "SLA пропущено",
      "sla_missed_resolution": "SLA пропущено"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Не в мережі",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Оновити"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Шукати чи перейти до",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Загальні",
      "REPORTS": "Звіти",
      "CONVERSATION": "Діалог",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Змінити виконавця",
      "CHANGE_PRIORITY": "Змінити пріоритет",
      "CHANGE_TEAM": "Змінити команду",
      "SNOOZE_CONVERSATION": "Відкласти розмову",
      "ADD_LABEL": "Додати мітку до діалогу",
      "REMOVE_LABEL": "Видалити мітку з діалогу",
      "SETTINGS": "Налаштування",
      "AI_ASSIST": "ШІ асистент",
      "APPEARANCE": "Оформлення",
      "SNOOZE_NOTIFICATION": "Відключити сповіщення"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти до панелі керування бесід",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти до панелі керування контактами",
      "GO_TO_REPORTS_OVERVIEW": "До Звітів",
      "GO_TO_CONVERSATION_REPORTS": "Перейти до Звітів про розмову",
      "GO_TO_AGENT_REPORTS": "Перейти до звітів Співробітника",
      "GO_TO_LABEL_REPORTS": "Перейти до Звітів з Мітками",
      "GO_TO_INBOX_REPORTS": "Перейти до Вхідних Звітів",
      "GO_TO_TEAM_REPORTS": "Перейти до Командних Звітів",
      "GO_TO_SETTINGS_AGENTS": "Перейдіть до налаштувань Співробітника",
      "GO_TO_SETTINGS_TEAMS": "Перейти до Налаштування команди",
      "GO_TO_SETTINGS_INBOXES": "Перейти до Налаштування вхідних повідомлень",
      "GO_TO_SETTINGS_LABELS": "Перейти до Налаштування Міток",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "До налаштувань швидкої відповіді",
      "GO_TO_SETTINGS_APPLICATIONS": "Перейти до Налаштування додатку",
      "GO_TO_SETTINGS_ACCOUNT": "Перейти до Налаштування облікового запису",
      "GO_TO_SETTINGS_PROFILE": "Перейти до Налаштування профілю",
      "GO_TO_NOTIFICATIONS": "Перейти до сповіщень",
      "ADD_LABELS_TO_CONVERSATION": "Додати мітку до діалогу",
      "ASSIGN_AN_AGENT": "Призначити агента",
      "AI_ASSIST": "ШІ асистент",
      "ASSIGN_PRIORITY": "Призначити пріоритет",
      "ASSIGN_A_TEAM": "Призначити команду",
      "MUTE_CONVERSATION": "Вимкнути звук для розмови",
      "UNMUTE_CONVERSATION": "Увімкнути звук для розмови",
      "REMOVE_LABEL_FROM_CONVERSATION": "Видалити мітку з діалогу",
      "REOPEN_CONVERSATION": "Повторно відкрити розмову",
      "RESOLVE_CONVERSATION": "Закрити розмову",
      "SEND_TRANSCRIPT": "Надіслати історію розмови на електронну пошту",
      "SNOOZE_CONVERSATION": "Відкласти розмову",
      "UNTIL_NEXT_REPLY": "До наступної відповіді",
      "UNTIL_NEXT_WEEK": "До наступного тижня",
      "UNTIL_TOMORROW": "До завтра",
      "UNTIL_NEXT_MONTH": "До наступного місяця",
      "AN_HOUR_FROM_NOW": "На годину з цього моменту",
      "UNTIL_CUSTOM_TIME": "Власний...",
      "CHANGE_APPEARANCE": "Змінити зовнішній вигляд",
      "LIGHT_MODE": "Світла",
      "DARK_MODE": "Темна",
      "SYSTEM_MODE": "Система",
      "SNOOZE_NOTIFICATION": "Відключити сповіщення"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Завантаження дашборду..."
  },
  "COMMON": {
    "OR": "Або",
    "CLICK_HERE": "натисніть тут"
  }
}
